// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const profoxyColors: ColorType = { ...colorPalette, primary: '#F36D00', secondary: '#F36D00' }

export const lightTheme = {
  colors: profoxyColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: profoxyColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: profoxyColors.dark,
    secondary: profoxyColors.grayText,
    disabled: profoxyColors.dark,
    link: profoxyColors.dark,
    hint: profoxyColors.dark,
    highlight: profoxyColors.primary,
    gray: profoxyColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: profoxyColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: profoxyColors.dark,
    color: profoxyColors.dark,
    border: profoxyColors.primary,
    scrollbarThumb: profoxyColors.primary,
    programTitle: profoxyColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: profoxyColors.dark,
        selected: profoxyColors.dark,
        progress: rgba(profoxyColors.primary, 0.3),
        past: rgba(profoxyColors.primary, 0.3),
        pastSelected: profoxyColors.dark,
        pastHover: profoxyColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(profoxyColors.primary, 0.1),
      },
      text: {
        empty: profoxyColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: profoxyColors.dark,
    subTitle: profoxyColors.grayText,
    bg: profoxyColors.dark,
    number: profoxyColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
